<script>
import store from './store';
import ScrollTo from './mixins/ScrollTo';

export default {
  el: '#app',

  name: 'App',

  store: store,

  mixins: [
    ScrollTo
  ],

  data: () => {
    return {
      isOpen: false,
      activeSearch: false,
      activeName: '1',
      swiperInstances: {}
    }
  },

  created() {
    this.$i18n.locale = 'pl'
  },

  mounted() {
    const newThis = this

    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.loaded = true
      }
    }

    const header = document.querySelector(".header");
    window.addEventListener('scroll', () => {
      const currentScrollHeader = window.pageYOffset;
      if (currentScrollHeader > 0) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    });

    if(!document.body.classList.contains('page-template-page-lp')) {

      const burgerMainAction = document.querySelector('#burger');


      function activeBurger() {
        burgerMainAction.classList.toggle('active')
        document.querySelector('body').classList.toggle('active')
        document.querySelector('header').classList.toggle('active')
      }

      burgerMainAction.addEventListener('click', activeBurger);

      document.querySelectorAll('.menu [data-scroll]').forEach((el) => {
        el.addEventListener('click', function (event) {
          newThis.ScrollTo(el.dataset.scroll, event)

          if (newThis.isOpen) {
            newThis.toggle();
          }
        }, false);
      })

      const first_submenu_exp = document.querySelectorAll(".header .header__desktop .submenu-expand");

      first_submenu_exp.forEach(e => {
        e.querySelector('.sub-menu .menu-item a').classList.add('first');

        e.addEventListener("mouseover", function (event) {

          const items = e.querySelectorAll('.menu-item-has-children');

          items.forEach(i => {
            i.addEventListener("mouseover", function (event) {
              e.querySelector('.sub-menu .menu-item a').classList.remove('first');
            })
          })
        });

        e.addEventListener("mouseout", function (event) {
          e.querySelector('.sub-menu .menu-item a').classList.add('first');
        });
      })

      let menuM = document.querySelectorAll(".header__mobile__container .menu-item-has-children");

      if (menuM) {
        menuM.forEach(function (item, index) {
          item.addEventListener('click', function () {
            item.classList.toggle('active');
          });
        });
      }
    }

    // Popup for success message
    document.addEventListener('wpcf7mailsent', function (event) {
      const newDiv = document.createElement('div');

      // Set some properties
      newDiv.id = 'popup-form-wpcf7-sent';
      newDiv.className = 'popup-form-wpcf7-sent';
      newDiv.innerHTML += '<div class="popup-form-wpcf7-error__content">Form has been successfully submitted!<span class="popup-form-button">Send another message</div>';

      const container = document.body;
      container.appendChild(newDiv);

      newDiv.addEventListener('click', function (event) {
        newDiv.remove();
      })
    }, false);

    // Popup for mail sending failure
    document.addEventListener('wpcf7mailfailed', function (event) {
      const newDiv = document.createElement('div');

      // Set some properties
      newDiv.id = 'popup-form-wpcf7-error';
      newDiv.className = 'popup-form-wpcf7-error';
      newDiv.innerHTML += '<div class="popup-form-wpcf7-error__content">Form cannot be submitted. Please contact us:<a class="base-form__error-link" href="mailto:contact@thecodest.co">contact@thecodest.co</a></div>';

      const container = document.body;
      container.appendChild(newDiv);

      newDiv.addEventListener('click', function (event) {
        newDiv.remove();
      })
    }, false);


    if (document.querySelector('.industries')) {

      const handleHashChange = () => {
        const hashValue = window.location.hash;
        if (hashValue) {
          const id = hashValue.replace('#', '');
          this.activeName = id;

          const sectionElement = document.querySelector('.industries');
          const targetElement = document.getElementById(id);

          if (sectionElement && targetElement) {
            const sectionOffset = sectionElement.offsetTop;
            window.scrollTo({
              top: sectionOffset - 300,
              behavior: "smooth"
            });

            setTimeout(() => {
              const targetOffset = targetElement.offsetTop;

              window.scrollTo({
                top: sectionOffset + targetOffset - 120,
                behavior: "smooth"
              });
            }, 1000);
          }
        } else {
          const industriesCollapse = this.$refs.industriesCollapse;
          this.activeName = industriesCollapse.name;
        }
      };

      handleHashChange();

      window.addEventListener('hashchange', handleHashChange);
    }


      /* Funkcja do usunięcia ukośnika z końca linku */
    function removeTrailingSlashFromLinks() {
      const links = document.querySelectorAll('.footer__bottom--item a, .wpcf7-acceptance a');

      links.forEach(function(link) {
          const url = link.getAttribute('href');
        if (url.endsWith('/')) {
          const newUrl = url.slice(0, -1);
          link.setAttribute('href', newUrl);
        }
      });
    }

    window.addEventListener('load', removeTrailingSlashFromLinks);

    // Filtry opinii: nie używać DOMContentLoaded — przy async bootstrapie Vue mounted()
    // odpala się już po tym zdarzeniu, więc listener nigdy się nie wykonywał.
    const bindOpinionsCategoryFilters = () => {
      document.querySelectorAll('.opinions__container').forEach((section) => {
        const categories = section.querySelectorAll('.opinions__category');
        const slides = section.querySelectorAll('.opinions__item');
        const swiperEl = section.querySelector('.opinions__swiper');
        if (!categories.length || !slides.length || !swiperEl) {
          return;
        }

        let attempts = 0;
        const maxAttempts = 120;
        const tryBind = () => {
          const swiperInstance = swiperEl.swiper;
          if (!swiperInstance) {
            attempts += 1;
            if (attempts < maxAttempts) {
              requestAnimationFrame(tryBind);
            }
            return;
          }

          categories.forEach((cat) => {
            cat.addEventListener('click', () => {
              categories.forEach((c) => c.classList.remove('active'));
              cat.classList.add('active');

              const catId = cat.id.replace(/^cat-/, '');
              slides.forEach((slide) => {
                if (catId === 'all' || slide.classList.contains(catId)) {
                  slide.style.display = '';
                } else {
                  slide.style.display = 'none';
                }
              });

              swiperInstance.update();
              swiperInstance.slideTo(0, 0);
            });
          });
        };
        tryBind();
      });
    };

    this.$nextTick(() => {
      bindOpinionsCategoryFilters();
    });
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen
      document.querySelector('body').classList.toggle('active')
    },

    onCollapseChange(activeNames) {
      //activeNames?.forEach((name) => {
        const refName = `case-studies-industries-${activeNames}`;

        if (this.$refs[refName] && !this.swiperInstances[refName]) {
          this.initSwiper(refName);
        }
      //});
    },

    initSwiper(refName) {
      this.$nextTick(() => {
        const swiperRef = this.$refs[refName];

        if (swiperRef) {
          this.swiperInstances[refName] = swiperRef.$swiper;
          this.swiperInstances[refName].update();
        }
      });
    },

    activateIndustry(id) {
      this.activeName = id; // Expand the correct collapse

      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            const y = el.getBoundingClientRect().top + window.pageYOffset - 190; // 100px higher
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }, 300)
      });
    },
  }
};
</script>
